import { createApp } from "vue";
import App from "./Main.vue";
import store from "@/store";
import PrimeVue from 'primevue/config';

//#region 프라임뷰 관련 스타일 파일 선언
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
//#endregion

import '@/assets/css/all.min.css';;
import '@/assets/css/koreit_common.css';
import '@/assets/css/koreit_main.css';
import router from "@/router";

const app = createApp(App);

app.use(store);
app.use(router)

// 프라임뷰 설정
app.use(PrimeVue);

app.mount("#wrap");